// Mock data for Costa Stone website
// This file contains all content that can be easily replaced with actual data

export const contactInfo = {
  phone: "+34 639 11 20 19",
  email: "info@costastone.es",
  whatsapp: "+34639112019",
  address: "Costa del Sol, Málaga, Spain",
  serviceArea: "Costa del Sol, Marbella, Málaga, and surrounding areas"
};

export const heroSection = {
  headline: "Premium Stone Carpet Solutions on Costa del Sol",
  subheadline: "Beautiful, durable, and low-maintenance resin bound stone surfaces for terraces, pool areas, driveways, stairs, and more.",
  tagline: "Because every step counts",
  subtagline: "It's not only about walking",
  ctaPrimary: "Request a Quote",
  ctaSecondary: "View Our Work",
  heroImage: "/images/hero-original.webp",
  heroVideo: "https://videos.pexels.com/video-files/6774235/6774235-uhd_2560_1440_30fps.mp4"
};

export const services = [
  {
    id: 1,
    title: "Terraces",
    description: "Transform your terrace into a stunning outdoor living space with our premium stone carpet. Perfect for creating a seamless, elegant finish that withstands the Mediterranean climate.",
    benefits: ["Weather resistant", "Non-slip surface", "Modern aesthetic", "Easy maintenance"],
    image: "/images/stone-carpet-terrace-costa-del-sol-1.webp",
    alt: "Stone carpet terrace installation Costa del Sol curved pattern design luxury outdoor living",
    titleAttr: "Premium terrace stone carpet Costa del Sol",
    icon: "Home"
  },
  {
    id: 2,
    title: "Pool Surrounds",
    description: "Create a safe, stylish pool area with our non-slip stone carpet. Ideal for poolside applications, offering comfort underfoot and excellent drainage.",
    benefits: ["Non-slip when wet", "UV resistant", "Comfortable underfoot", "Quick drainage"],
    image: "/images/stone-carpet-pool-surrounds-costa-del-sol-1.webp",
    alt: "Stone carpet pool surround Costa del Sol modern luxury villa outdoor entertaining area",
    titleAttr: "Premium pool surround stone carpet",
    icon: "Waves"
  },
  {
    id: 3,
    title: "Driveways",
    description: "Enhance your property's curb appeal with a durable stone carpet driveway. Strong enough to handle vehicles while maintaining a premium appearance.",
    benefits: ["High durability", "Elegant finish", "Low maintenance", "Long-lasting"],
    image: "/images/stone-carpet-driveway-costa-del-sol-3.webp",
    alt: "Stone carpet driveway Costa del Sol modern luxury villa entrance premium finish",
    titleAttr: "Luxury driveway stone carpet Costa del Sol",
    icon: "Car"
  },
  {
    id: 4,
    title: "Stairs & Steps",
    description: "Make your stairs safe and beautiful with our stone carpet solution. Provides excellent grip and creates a cohesive design throughout your property.",
    benefits: ["Enhanced safety", "Slip-resistant", "Seamless design", "Durable finish"],
    image: "/images/stone-carpet-stairs-costa-del-sol-1.webp",
    alt: "Stone carpet stairs Costa del Sol decorative anti-slip steps geometric pattern black white",
    titleAttr: "Premium stairs stone carpet Costa del Sol",
    icon: "MoveVertical"
  },
  {
    id: 5,
    title: "Balconies",
    description: "Upgrade your balcony with a modern stone carpet surface. Weather-resistant and stylish, perfect for creating your own private outdoor retreat.",
    benefits: ["Weather proof", "Lightweight", "Modern look", "Easy to clean"],
    image: "/images/stone-carpet-balcony-costa-del-sol-2.webp",
    alt: "Resin bound balcony Costa del Sol compass rose pattern ocean view luxury terrace",
    titleAttr: "Premium balcony stone carpet Costa del Sol",
    icon: "Building2"
  },
  {
    id: 6,
    title: "Walkways & Patios",
    description: "Create beautiful pathways and patio areas that blend seamlessly with your landscape. Our stone carpet provides a sophisticated finish for any outdoor space.",
    benefits: ["Seamless finish", "Versatile design", "Natural appearance", "All-weather"],
    image: "/images/stone-carpet-walkway-patio-costa-del-sol-1.webp",
    alt: "Stone carpet patio wave pattern Costa del Sol modern outdoor design artistic finish",
    titleAttr: "Premium walkway patio stone carpet",
    icon: "Footprints"
  },
  {
    id: 7,
    title: "Garages",
    description: "Transform your garage floor with our industrial-strength stone carpet. Resistant to oil stains and heavy traffic while maintaining an elegant appearance.",
    benefits: ["Oil resistant", "Heavy-duty", "Easy to clean", "Professional finish"],
    image: "/images/stone-carpet-garage-costa-del-sol-2.webp",
    alt: "Resin bound showroom floor Costa del Sol commercial space geometric pattern heavy duty",
    titleAttr: "Professional garage stone carpet Costa del Sol",
    icon: "Car"
  }
];

export const benefits = [
  {
    icon: "AlertTriangle",
    title: "Non-Slip & Safe",
    description: "Perfect grip even when wet. Ideal for pools, terraces and outdoor areas."
  },
  {
    icon: "Sun",
    title: "UV & Heat Resistant",
    description: "Designed for Costa del Sol climate. No fading, cracking or overheating."
  },
  {
    icon: "Droplets",
    title: "Low Maintenance",
    description: "No weeds, no loose stones. Easy cleaning and long-lasting performance."
  },
  {
    icon: "Sparkles",
    title: "Seamless Premium Look",
    description: "Elegant, modern finish that instantly upgrades your property."
  }
];

export const whyChooseUs = [
  {
    icon: "Award",
    title: "Expert Craftsmanship",
    description: "Our team delivers exceptional workmanship with attention to every detail."
  },
  {
    icon: "MapPin",
    title: "Local Expertise",
    description: "Deep knowledge of Costa del Sol climate and ideal solutions for the region."
  },
  {
    icon: "Users",
    title: "Customer-Focused",
    description: "We prioritize your satisfaction and work closely with you throughout the project."
  },
  {
    icon: "CheckCircle",
    title: "Quality Materials",
    description: "We use only premium materials designed for Mediterranean conditions."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Maria González",
    location: "Marbella",
    rating: 5,
    text: "The transformation of our pool area is incredible. The stone carpet looks beautiful and is safe for our children. Highly professional service from start to finish.",
    project: "Pool Surround"
  },
  {
    id: 2,
    name: "James Wilson",
    location: "Estepona",
    rating: 5,
    text: "We renovated our entire terrace with stone carpet and couldn't be happier. It's modern, elegant, and requires almost no maintenance. Excellent work!",
    project: "Terrace Renovation"
  },
  {
    id: 3,
    name: "Carmen Martínez",
    location: "Fuengirola",
    rating: 5,
    text: "Professional, reliable, and the result exceeded our expectations. Our driveway looks stunning and has completely changed the appearance of our property.",
    project: "Driveway Installation"
  }
];

export const faqData = [
  {
    question: "What is stone carpet?",
    answer: "Stone carpet, also known as resin bound stone, is a surfacing solution made by mixing natural stone aggregates with a clear resin binder. The result is a seamless, durable, and attractive surface perfect for outdoor and indoor applications."
  },
  {
    question: "Is it suitable for outdoor use on Costa del Sol?",
    answer: "Absolutely! Our stone carpet is specifically designed for outdoor use and is ideal for the Mediterranean climate of Costa del Sol. It's UV resistant, weather-proof, and can handle temperature variations with ease."
  },
  {
    question: "Is stone carpet slippery when wet?",
    answer: "No, stone carpet provides excellent grip even when wet, making it perfect for pool areas, terraces, and other outdoor spaces where safety is important. The textured surface ensures a non-slip finish."
  },
  {
    question: "How long does installation take?",
    answer: "Installation time depends on the size and complexity of the project. A typical terrace or pool area can usually be completed within 1-3 days. We'll provide a detailed timeline during your consultation."
  },
  {
    question: "Can it be installed over existing surfaces?",
    answer: "Yes, in many cases stone carpet can be applied over existing surfaces such as concrete, tiles, or old paving, provided the base is sound and properly prepared. This makes it an excellent renovation option."
  },
  {
    question: "Is it easy to maintain?",
    answer: "Stone carpet is very low maintenance. Regular sweeping and occasional washing with water is usually all that's needed to keep it looking great. It doesn't require sealing or special treatments."
  },
  {
    question: "Is it suitable for pool areas?",
    answer: "Yes, stone carpet is ideal for pool surrounds. It's non-slip when wet, comfortable to walk on barefoot, provides good drainage, and is resistant to chlorine and UV exposure."
  },
  {
    question: "How long does stone carpet last?",
    answer: "With proper installation and normal use, stone carpet can last 15-25 years or more. It's a long-term investment in your property that maintains its appearance over time."
  },
  {
    question: "What colors and styles are available?",
    answer: "Stone carpet is available in a wide range of natural stone colors and aggregate sizes, allowing you to choose the perfect match for your property's aesthetic. We'll show you samples during consultation."
  },
  {
    question: "Do you provide free quotes?",
    answer: "Yes, we offer free, no-obligation quotes. Contact us to schedule a consultation where we can assess your project and provide a detailed estimate."
  }
];

export const galleryProjects = [
  // Terraces Category
  {
    id: 1,
    title: "Luxury Terrace with Curved Pattern Design",
    category: "Terraces",
    location: "Marbella",
    image: "/images/stone-carpet-terrace-costa-del-sol-1.webp",
    alt: "Stone carpet terrace installation Costa del Sol curved pattern design luxury outdoor living",
    titleAttr: "Luxury stone carpet terrace with curved pattern"
  },
  {
    id: 2,
    title: "Modern Terrace with Glass Balustrade",
    category: "Terraces",
    location: "Estepona",
    image: "/images/stone-carpet-terrace-costa-del-sol-2.webp",
    alt: "Resin bound stone carpet terrace Costa del Sol modern outdoor space glass railing",
    titleAttr: "Modern terrace resin bound stone surface"
  },
  {
    id: 3,
    title: "Contemporary Terrace with Geometric Pattern",
    category: "Terraces",
    location: "Málaga",
    image: "/images/stone-carpet-terrace-costa-del-sol-3.webp",
    alt: "Stone carpet terrace Costa del Sol geometric pattern design contemporary outdoor flooring",
    titleAttr: "Geometric pattern stone carpet terrace"
  },
  {
    id: 4,
    title: "Evening Terrace with Ambient Lighting",
    category: "Terraces",
    location: "Fuengirola",
    image: "/images/stone-carpet-terrace-costa-del-sol-4.webp",
    alt: "Resin bound terrace Costa del Sol evening ambiance modern geometric stone carpet design",
    titleAttr: "Evening terrace with stone carpet"
  },
  {
    id: 5,
    title: "Terrace with Spiral Pattern and View",
    category: "Terraces",
    location: "Mijas",
    image: "/images/stone-carpet-terrace-costa-del-sol-5.webp",
    alt: "Stone carpet terrace installation Costa del Sol spiral pattern panoramic view luxury outdoor",
    titleAttr: "Spiral pattern terrace stone carpet"
  },
  {
    id: 6,
    title: "Natural Stone Carpet Terrace with Plants",
    category: "Terraces",
    location: "Benalmádena",
    image: "/images/stone-carpet-terrace-costa-del-sol-6.webp",
    alt: "Stone carpet terrace Costa del Sol modern outdoor surface design natural aesthetic",
    titleAttr: "Natural terrace stone carpet design"
  },
  // Pool Surrounds Category
  {
    id: 7,
    title: "Luxury Pool Deck with Modern Villa",
    category: "Pool Surrounds",
    location: "Marbella",
    image: "/images/stone-carpet-pool-surrounds-costa-del-sol-1.webp",
    alt: "Stone carpet pool surround Costa del Sol modern luxury villa outdoor entertaining area",
    titleAttr: "Luxury pool deck stone carpet"
  },
  {
    id: 8,
    title: "Contemporary Pool Area with Glass Railing",
    category: "Pool Surrounds",
    location: "Estepona",
    image: "/images/stone-carpet-pool-surrounds-costa-del-sol-2.webp",
    alt: "Resin bound pool surround Costa del Sol contemporary design glass balustrade modern outdoor",
    titleAttr: "Contemporary pool area resin bound"
  },
  {
    id: 9,
    title: "Mediterranean Pool Surround with Ocean View",
    category: "Pool Surrounds",
    location: "Málaga",
    image: "/images/stone-carpet-pool-surrounds-costa-del-sol-3.webp",
    alt: "Stone carpet pool deck Costa del Sol Mediterranean style ocean view luxury outdoor living",
    titleAttr: "Mediterranean pool deck stone carpet"
  },
  {
    id: 10,
    title: "Premium Pool Deck with Infinity Edge",
    category: "Pool Surrounds",
    location: "Fuengirola",
    image: "/images/stone-carpet-pool-surrounds-costa-del-sol-4.webp",
    alt: "Resin bound stone pool surround Costa del Sol infinity pool modern luxury outdoor design",
    titleAttr: "Premium infinity pool deck"
  },
  {
    id: 11,
    title: "Elegant Pool Area with Villa Setting",
    category: "Pool Surrounds",
    location: "Mijas",
    image: "/images/stone-carpet-pool-surrounds-costa-del-sol-5.webp",
    alt: "Stone carpet pool surround Costa del Sol modern outdoor surface white villa luxury",
    titleAttr: "Elegant pool area stone carpet"
  },
  {
    id: 12,
    title: "Natural Stone Pool Edge Detail",
    category: "Pool Surrounds",
    location: "Torremolinos",
    image: "/images/stone-carpet-pool-surrounds-costa-del-sol-6.webp",
    alt: "Resin bound stone pool area Costa del Sol luxury finish pebble texture detail",
    titleAttr: "Natural pool edge stone carpet"
  },
  // Walkways & Patios Category
  {
    id: 13,
    title: "Contemporary Wave Pattern Patio",
    category: "Walkways & Patios",
    location: "Marbella",
    image: "/images/stone-carpet-walkway-patio-costa-del-sol-1.webp",
    alt: "Stone carpet patio wave pattern Costa del Sol modern outdoor design artistic finish",
    titleAttr: "Wave pattern stone carpet patio"
  },
  {
    id: 14,
    title: "Geometric Garden Walkway Design",
    category: "Walkways & Patios",
    location: "Estepona",
    image: "/images/stone-carpet-walkway-patio-costa-del-sol-2.webp",
    alt: "Resin bound walkway geometric pattern Costa del Sol modern garden outdoor surface",
    titleAttr: "Geometric walkway stone carpet"
  },
  {
    id: 15,
    title: "Serene Garden Patio with Seating",
    category: "Walkways & Patios",
    location: "Málaga",
    image: "/images/stone-carpet-walkway-patio-costa-del-sol-3.webp",
    alt: "Stone carpet garden patio Costa del Sol modern outdoor living space natural aggregate",
    titleAttr: "Garden patio stone carpet"
  },
  {
    id: 16,
    title: "Stone Carpet Patio with White River Rock Border",
    category: "Walkways & Patios",
    location: "Fuengirola",
    image: "/images/stone-carpet-walkway-patio-costa-del-sol-4.webp",
    alt: "Stone carpet decorative patio Costa del Sol modern outdoor surface white rock edging",
    titleAttr: "Decorative patio stone carpet"
  },
  {
    id: 17,
    title: "Modern Driveway Entrance with Landscaping",
    category: "Driveways",
    location: "Mijas",
    image: "/images/stone-carpet-walkway-patio-costa-del-sol-5.webp",
    alt: "Stone carpet driveway Costa del Sol modern entrance landscaping luxury home",
    titleAttr: "Modern driveway stone carpet Costa del Sol"
  },
  {
    id: 18,
    title: "Luxury Villa Driveway with Stone Edging",
    category: "Driveways",
    location: "Torremolinos",
    image: "/images/stone-carpet-walkway-patio-costa-del-sol-6.webp",
    alt: "Stone carpet driveway Costa del Sol outdoor landscaping luxury villa stone edging",
    titleAttr: "Luxury villa driveway stone carpet"
  },
  // Driveways Category
  {
    id: 20,
    title: "Modern Garden Patio Installation",
    category: "Walkways & Patios",
    location: "Marbella",
    image: "/images/stone-carpet-driveway-costa-del-sol-1.webp",
    alt: "Stone carpet garden patio Costa del Sol modern outdoor surface premium finish",
    titleAttr: "Modern garden patio stone carpet"
  },
  {
    id: 21,
    title: "Sun Design Patio Feature",
    category: "Walkways & Patios",
    location: "Estepona",
    image: "/images/stone-carpet-driveway-costa-del-sol-2.webp",
    alt: "Resin bound patio Costa del Sol luxury home exterior decorative sun pattern",
    titleAttr: "Decorative patio sun design"
  },
  {
    id: 22,
    title: "Luxury Villa Entrance at Sunset",
    category: "Driveways",
    location: "Málaga",
    image: "/images/stone-carpet-driveway-costa-del-sol-3.webp",
    alt: "Stone carpet driveway Costa del Sol modern luxury villa entrance premium finish",
    titleAttr: "Luxury villa driveway stone carpet"
  },
  {
    id: 23,
    title: "Curved Driveway Mediterranean Style",
    category: "Driveways",
    location: "Fuengirola",
    image: "/images/stone-carpet-driveway-costa-del-sol-4.webp",
    alt: "Resin bound driveway curved design Costa del Sol luxury landscaping",
    titleAttr: "Curved driveway resin bound"
  },
  {
    id: 24,
    title: "Hillside Property Driveway Sunset View",
    category: "Driveways",
    location: "Mijas",
    image: "/images/stone-carpet-driveway-costa-del-sol-5.webp",
    alt: "Stone carpet driveway hillside property Costa del Sol sunset ocean view",
    titleAttr: "Hillside driveway sunset view"
  },
  {
    id: 25,
    title: "Garden Path Driveway Connection",
    category: "Driveways",
    location: "Torremolinos",
    image: "/images/stone-carpet-driveway-costa-del-sol-6.webp",
    alt: "Decorative resin bound driveway Costa del Sol premium landscaping curved pathway",
    titleAttr: "Garden driveway landscaping"
  },
  // Stairs & Steps Category
  {
    id: 27,
    title: "Geometric Pattern Steps Design",
    category: "Stairs & Steps",
    location: "Marbella",
    image: "/images/stone-carpet-stairs-costa-del-sol-1.webp",
    alt: "Stone carpet stairs Costa del Sol decorative anti-slip steps geometric pattern black white",
    titleAttr: "Geometric pattern stairs stone carpet"
  },
  {
    id: 28,
    title: "Modern Neutral Steps Installation",
    category: "Stairs & Steps",
    location: "Estepona",
    image: "/images/stone-carpet-stairs-costa-del-sol-2.webp",
    alt: "Resin bound staircase Costa del Sol neutral beige finish anti-slip outdoor steps",
    titleAttr: "Modern neutral stairs installation"
  },
  {
    id: 29,
    title: "Contemporary Villa Entrance Steps",
    category: "Stairs & Steps",
    location: "Málaga",
    image: "/images/stone-carpet-stairs-costa-del-sol-3.webp",
    alt: "Stone carpet entrance steps Costa del Sol modern villa black decorative pattern driveway",
    titleAttr: "Contemporary villa entrance steps"
  },
  {
    id: 30,
    title: "Mediterranean Garden Steps",
    category: "Stairs & Steps",
    location: "Fuengirola",
    image: "/images/stone-carpet-stairs-costa-del-sol-4.webp",
    alt: "Resin bound garden stairs Costa del Sol natural stone finish lavender landscaping",
    titleAttr: "Mediterranean garden steps"
  },
  {
    id: 31,
    title: "Decorative Geometric Staircase",
    category: "Stairs & Steps",
    location: "Mijas",
    image: "/images/stone-carpet-stairs-costa-del-sol-5.webp",
    alt: "Stone carpet decorative staircase Costa del Sol geometric pattern anti-slip modern design",
    titleAttr: "Decorative geometric staircase"
  },
  {
    id: 32,
    title: "Elegant Garden Steps with LED Lighting",
    category: "Stairs & Steps",
    location: "Benalmádena",
    image: "/images/stone-carpet-stairs-costa-del-sol-6.webp",
    alt: "Stone carpet outdoor steps Costa del Sol elegant finish LED lighting landscaping",
    titleAttr: "Elegant garden steps with lighting"
  },
  // Balconies Category
  {
    id: 33,
    title: "Decorative Balcony with Gecko Pattern",
    category: "Balconies",
    location: "Marbella",
    image: "/images/stone-carpet-balcony-costa-del-sol-1.webp",
    alt: "Stone carpet balcony Costa del Sol decorative gecko pattern resin bound terrace",
    titleAttr: "Decorative balcony gecko pattern"
  },
  {
    id: 34,
    title: "Luxury Balcony with Compass Rose Design",
    category: "Balconies",
    location: "Estepona",
    image: "/images/stone-carpet-balcony-costa-del-sol-2.webp",
    alt: "Resin bound balcony Costa del Sol compass rose pattern ocean view luxury terrace",
    titleAttr: "Luxury balcony compass rose"
  },
  {
    id: 35,
    title: "Modern Curved Balcony with Artistic Pattern",
    category: "Balconies",
    location: "Málaga",
    image: "/images/stone-carpet-balcony-costa-del-sol-3.webp",
    alt: "Stone carpet curved balcony Costa del Sol modern artistic pattern decorative finish",
    titleAttr: "Modern curved balcony design"
  },
  {
    id: 36,
    title: "Contemporary Balcony Natural Finish",
    category: "Balconies",
    location: "Fuengirola",
    image: "/images/stone-carpet-balcony-costa-del-sol-4.webp",
    alt: "Resin bound balcony Costa del Sol natural stone finish modern outdoor terrace",
    titleAttr: "Contemporary balcony natural finish"
  },
  {
    id: 37,
    title: "Serene Balcony with Rattan Furniture",
    category: "Balconies",
    location: "Benalmádena",
    image: "/images/stone-carpet-balcony-costa-del-sol-5.webp",
    alt: "Stone carpet balcony Costa del Sol serene outdoor terrace rattan furniture olive trees",
    titleAttr: "Serene balcony with rattan furniture"
  },
  {
    id: 38,
    title: "Modern Balcony with Minimalist Design",
    category: "Balconies",
    location: "Torremolinos",
    image: "/images/stone-carpet-balcony-costa-del-sol-6.webp",
    alt: "Resin bound balcony Costa del Sol modern minimalist design natural stone terrace",
    titleAttr: "Modern minimalist balcony design"
  },
  // Garages Category
  {
    id: 39,
    title: "Modern Residential Garage Floor",
    category: "Garages",
    location: "Marbella",
    image: "/images/stone-carpet-garage-costa-del-sol-1.webp",
    alt: "Stone carpet garage floor Costa del Sol modern residential two-tone decorative finish",
    titleAttr: "Modern residential garage floor"
  },
  {
    id: 40,
    title: "Commercial Showroom Floor",
    category: "Garages",
    location: "Estepona",
    image: "/images/stone-carpet-garage-costa-del-sol-2.webp",
    alt: "Resin bound showroom floor Costa del Sol commercial space geometric pattern heavy duty",
    titleAttr: "Commercial showroom stone carpet"
  },
  {
    id: 41,
    title: "Professional Garage Floor Installation",
    category: "Garages",
    location: "Málaga",
    image: "/images/stone-carpet-garage-costa-del-sol-3.webp",
    alt: "Stone carpet garage flooring Costa del Sol professional finish durable resin bound surface",
    titleAttr: "Professional garage floor"
  },
  {
    id: 42,
    title: "Elegant Lounge with Stone Carpet Flooring",
    category: "Garages",
    location: "Fuengirola",
    image: "/images/stone-carpet-garage-costa-del-sol-4.webp",
    alt: "Stone carpet interior flooring Costa del Sol elegant lounge decorative pattern resin bound",
    titleAttr: "Elegant lounge stone carpet"
  },
  {
    id: 43,
    title: "Premium Residential Garage Floor",
    category: "Garages",
    location: "Benalmádena",
    image: "/images/stone-carpet-garage-costa-del-sol-5.webp",
    alt: "Resin bound garage floor Costa del Sol premium residential heavy duty anti-slip surface",
    titleAttr: "Premium residential garage"
  },
  {
    id: 44,
    title: "Modern Garage Floor Installation",
    category: "Garages",
    location: "Torremolinos",
    image: "/images/stone-carpet-garage-costa-del-sol-6.webp",
    alt: "Stone carpet garage installation Costa del Sol modern durable resin bound flooring system",
    titleAttr: "Modern garage installation"
  }
];

export const aboutContent = {
  title: "About Costa Stone",
  subtitle: "Your trusted partner for premium stone carpet installations",
  description: "Costa Stone specializes in creating beautiful, durable surfaces using high-quality resin bound stone technology. We bring elegance and functionality to outdoor and indoor spaces across the Costa del Sol region.",
  mission: "Our mission is to transform outdoor spaces into stunning, long-lasting surfaces that enhance property value and lifestyle. We combine premium materials with expert craftsmanship to deliver results that exceed expectations.",
  aboutImage: "/images/about-original.webp",
  values: [
    {
      title: "Quality First",
      description: "We never compromise on materials or workmanship, ensuring every project meets the highest standards."
    },
    {
      title: "Customer Satisfaction",
      description: "Your vision and satisfaction drive everything we do. We work closely with you throughout the entire process."
    },
    {
      title: "Professional Service",
      description: "Reliable, punctual, and professional service from initial consultation to project completion."
    },
    {
      title: "Local Expertise",
      description: "Deep understanding of Costa del Sol's climate and the best solutions for the Mediterranean environment."
    }
  ]
};

export const whatIsStoneContent = {
  title: "What is Stone Carpet?",
  subtitle: "Understanding resin bound stone surfaces",
  intro: "Stone carpet, also known as resin bound stone or resin bound surfacing, is a modern paving solution that combines natural stone aggregates with a clear polyurethane resin. The result is a smooth, seamless, and highly durable surface that's both beautiful and practical.",
  whatIsImage: "/images/what-is-original.webp",
  howItWorks: {
    title: "How It Works",
    steps: [
      {
        number: "01",
        title: "Preparation",
        description: "The existing surface is thoroughly cleaned and prepared, or a new base is created to ensure optimal adhesion and longevity."
      },
      {
        number: "02",
        title: "Mixing",
        description: "Natural stone aggregates are carefully mixed with a specialist UV-resistant resin binder to achieve the perfect consistency."
      },
      {
        number: "03",
        title: "Application",
        description: "The mixture is applied evenly across the prepared surface, creating a seamless finish with no joints or gaps."
      },
      {
        number: "04",
        title: "Finishing",
        description: "The surface is smoothed and leveled to perfection, then left to cure, creating a strong, durable finish."
      }
    ]
  },
  advantages: [
    {
      title: "Seamless Finish",
      description: "No joints or gaps means no weeds, no uneven surfaces, and a sleek modern appearance."
    },
    {
      title: "Highly Durable",
      description: "Resistant to cracking, fading, and weather damage. Built to last for decades."
    },
    {
      title: "Versatile Applications",
      description: "Suitable for driveways, terraces, pool areas, walkways, stairs, and more."
    },
    {
      title: "Low Maintenance",
      description: "Simple cleaning with water is all that's needed. No sealing or special treatments required."
    },
    {
      title: "Permeable Options",
      description: "Can be made permeable for excellent drainage, reducing water pooling and runoff."
    },
    {
      title: "Aesthetic Appeal",
      description: "Available in numerous colors and stone sizes to complement any architectural style."
    }
  ],
  whyChoose: {
    title: "Why Choose Stone Carpet Over Traditional Surfaces?",
    comparisons: [
      {
        traditional: "Tiles",
        stoneCarpet: "No grout lines, no cracking, seamless appearance, and better grip when wet."
      },
      {
        traditional: "Concrete",
        stoneCarpet: "More attractive, better texture, non-slip, and available in many colors."
      },
      {
        traditional: "Paving Stones",
        stoneCarpet: "No gaps for weeds, no uneven surfaces, faster installation, and modern aesthetic."
      },
      {
        traditional: "Paint or Coating",
        stoneCarpet: "Much more durable, won't chip or peel, better texture, and longer-lasting."
      }
    ]
  }
};
